<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top">
          <div></div>
          <!-- <el-input
            class="search-input"
            placeholder="请输入搜索内容"
            v-model="search_name"
            :header-cell-style="getRowClass"
            prefix-icon="el-icon-search" @keyup.enter.native="searchName">
          </el-input> -->
        </div>
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          :row-class-name="rowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="device_name"
            label="仪器名称">
          </el-table-column>
          <el-table-column
            prop="amount"
            label="数量">
          </el-table-column>
          <el-table-column
            prop="price"
            label="价格">
          </el-table-column>
          <el-table-column
            label="方式">
            <template slot-scope="scope">
              <span>{{measureArr[scope.row.measure_type]}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="measure"
            label="范围">
          </el-table-column>
          <el-table-column
            prop="grade"
            label="等级">
          </el-table-column>
          <el-table-column label="操作" >
            <template slot-scope="scope">
              <el-button
                class="apply-btn"
                :disabled="scope.row.apply"
                @click="handleApply(scope.row, scope.$index)"
                >
                 {{scope.row.apply === false ?'领取' : '已领取'}}
                </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 点击发送按钮的 弹出框 start -->
    <div  class="delete-container" v-if="sendShow">
      <div class="delete-content">
        <i class="el-icon-close close-icon" @click="cancleDelete"></i>
        <!-- <div class="delete-title">
          <i class="el-icon-warning"></i>
          提示
        </div> -->
        <p class="delete-txt">确认领取该仪器?</p>
        <div class="btn-container">
          <el-button class="btn-list cancle-btn" @click="cancleDelete">取消</el-button>
          <el-button class="btn-list sure-btn" @click="sureDelete">确认</el-button>
        </div>
      </div>
    </div>
    <!-- 点击发送按钮的 弹出框 end -->
  </div>
</template>

<script type='text/ecmascript-6'>
export default {
  data () {
    return {
      lab_order_id: '',
      empty: '订单没有仪器信息！',
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      search_name: '',
      measureArr: ['校准', '检定', '检测'],
      sendShow: false,
      device: {},
      deviceIndex: '',
      search_show: false
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    rowClass({row}){
      if (row.type == 1) {
        return 'row-color'
      }
    },
    initData () { // 初始化页面 发送 订单ID 获取订单详情
      let that = this
      this.lab_order_id = this.$route.query.lab_order_id
      this.type = this.$route.query.type
      let fun = ''
      if (this.$route.query.kind == 'in') {
        fun = 'seeUnworkOrderDetail'
      } else {
        fun = 'seeUnworkOrderDetailOut'
      }
      this.$api[fun]({
        lab_order_id: that.lab_order_id,
        type: that.type,
        page_num: (that.page-1)  * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.device.length > 0) {
          that.tableData = res.data.device.map(item => {
            item.apply = false
            return item
          })
          that.total = Number(res.data.total)
        } else {
          that.tableData = []
        }
      }).catch(err => {
        that.$message({
          message: err,
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      if (this.search_show) {
        this.searchName()
      } else {
        this.initData()
      }
    },
    searchName () { // 输入名字搜索
      let that = this
      if (!this.search_show) {
        this.search_show = true
        this.page = 1
      }
      if (that.search_name) {
        this.$api.searchUnfilledOrder({
          search: that.search_name,
          page_num: (that.page-1) * this.limit
        }).then(res => {
          if (res.data.detail.length > 0) {
            that.tableData = res.data.detail
            that.total = Number(res.data.total)
          } else {
            that.tableData = []
            that.total = 0
          }
        }).catch(err => {
          that.$message({
            message: err,
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          message: '搜索不能为空！！',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    handleApply (row, index) { // 点击申请
      this.device = row
      this.deviceIndex = index
      this.sendShow = true
    },
    cancleDelete () { // 取消次操作
      this.sendShow = false
      this.$message({
        type: 'info',
        message: '取消此操作！',
        customClass: 'msg-position',
        showClose: true
      })
    },
    sureDelete () { // 确认领取
      let that = this
      that.$api.sureReceiveDevice({
        item_id: that.device.item_id,
        type: that.device.type
      }).then(res => {
        if (res.data.msg === true) {
          that.tableData[that.deviceIndex].apply = true
          that.sendShow = false
          that.$message({
            type: 'success',
            message: '领取成功！！',
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: '领取失败！！',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
  },
  components: {
  },
  watch: {
    /* '$router': 'initData' */
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/box.styl'
.delete-container
  position:fixed;
  left:0;
  right:0;
  top:0;
  bottom:0;
  background-color:rgba(0, 0, 0, 0.2);
  z-index:10000;
  display: flex;
  justify-content: center;
  align-items: center;
  .delete-content
    background:#fff;
    z-index: 100001;
    width: 20rem;
    padding: 2rem 1rem;
    border-radius: 0.4rem;
    position: relative;
    .delete-title
      text-align:center;
      font-size:0.8rem;
      .el-icon-warning
        color:red;
        font-size:1rem;
    .delete-txt
      text-align: center;
      margin-top:1rem;
      font-size:0.9rem;
      font-weight:medium;
      color:#666;
    .btn-container
      margin-top:1.5rem;
      padding: 0rem 2rem;
      width:100%;
      color: #666;
      box-sizing:border-box;
      display: flex;
      .btn-list
        flex:1;
        color:#fff;
        border:0;
        &.cancle-btn
          background: #cfcfcf;
          color:#fff;
          span
            color:#fff;
        &.sure-btn
          background: #EF757A;
          span
            color:#fff;
    .close-icon
      position: absolute;
      top:0.5rem;
      right:0.5rem;
      color:#9a9a9a;
      font-size:1.2rem;
</style>
